/*
  NUDIENT: Det sticky köpfältet, StickyBuyBar, paket B5, M-083 och M-088.
  Plan: nudient/PLAN-B5-kopfalt.md punkt 2, 3 och 8. Laddas av
  sections/nudient-sticky-buy-bar.liquid.

  - Fältet visas när köpkolumnens köpyta har rullat upp ovanför skärmen,
    1297:1750, och döljs när den syns igen eller inte är nådd än. Köpytan är
    Horizons köpknappar, .buy-buttons-block, eller bevakningsblocket,
    .nudient-notify-me, när produkten är slut och köpknappen är dold.
  - Döljs när sidfoten syns, M-088 punkt 3. Döljs inte för att en chatt
    finns på sidan, M-088 tillägget punkt 3.
  - Döljs när en dialog eller mobilmenyn är öppen. Det sköts av CSS:en.
  - Ligger kvar så länge fokus är i fältet, också när sidfoten syns, så att
    fokus aldrig försvinner för den som använder tangentbordet, M-088
    tillägget punkt 2. Döljs så fort fokus lämnar det. Dolt fält är inert.
  - ADD TO CART trycker på köpkolumnens egen köpknapp, som Horizons fält
    gör i assets/sticky-add-to-cart.js. Köpet går genom Horizons
    köpformulär, med korsförsäljningen och tillvalet om de är ikryssade.
    puppet stänger av knappens egen animering i kolumnen, och återställs
    när varukorgen har svarat.
  - NOTIFY ME trycker på bevakningsblockets knapp, M-033. Finns inget
    bevakningsblock tas knappen bort, och bara SOLD OUT står kvar.

  Värden som inte är tokens:
  - true och false i data-shown och puppet: programvärden.
  - data-nudient-sticky-bar-shown på html: fältet syns och ingen låda eller
    mobilmenyn är öppen. Läses av regeln för Gorgias och Klaviyo. :has() i
    regeln räknades inte om i Chrome, provat 9 oktober 2026.
  - open: attributet som lådorna och mobilmenyn får när de är öppna.
  - footer och [class*="footer-group"]: sidfoten, som i Horizons fält.
*/

import { StandardEvents } from '@shopify/events';

const bar = document.querySelector('[data-nudient-sticky-bar]');
if (bar && !bar.dataset.ready) setup(bar);

function setup(bar) {
  bar.dataset.ready = 'true';
  const soldOut = bar.hasAttribute('data-sold-out');
  const main = document.querySelector('.product-information:has(.nudient-product-header)') || document;
  const target = soldOut ? main.querySelector('.nudient-notify-me') : main.querySelector('.buy-buttons-block');
  const footer = document.querySelector('footer') ?? document.querySelector('[class*="footer-group"]');

  const notify = bar.querySelector('[data-nudient-sticky-notify]');
  const notifyTarget = main.querySelector('.nudient-notify-me__button');
  if (notify && !notifyTarget) notify.remove();

  if (!target) return;

  let passed = false;
  let atFooter = false;

  const update = () => {
    const focused = bar.contains(document.activeElement);
    const show = focused || (passed && !atFooter);
    bar.dataset.shown = String(show);
    bar.inert = !show;
    /* På roten, för regeln som flyttar upp Gorgias och Klaviyo i
       assets/nudient-sticky-bar.css. Bara när fältet syns på riktigt,
       alltså också när ingen låda eller mobilmenyn är öppen */
    const covered = Boolean(document.querySelector('dialog[open], #Details-menu-drawer-container[open]'));
    document.documentElement.toggleAttribute('data-nudient-sticky-bar-shown', show && !covered);
  };

  /* Läget räknas vid varje rullning och storleksändring. Webbläsaren skickar
     rullningen högst en gång per bildruta. En IntersectionObserver, som
     Horizons fält använder, svarar bara när köpytan går in i eller ut ur
     bild, och missar ett hopp förbi den, till exempel med End eller en länk
     i mobil, där köpytan ligger under skärmkanten när sidan laddas. Läget
     räknas också om när sidans höjd ändras, eftersom sidan växer medan
     bilder och rekommendationer laddas och sidfoten då flyttas utan att
     kunden rullar. Provat 9 oktober 2026.
     Från 990 rullar Horizon .page-wrapper och inte fönstret, assets/base.css
     rad 28 och assets/scroll-container.js, och rullningen på ett element
     når inte fönstret. Därför lyssnar skriptet på dokumentet med capture,
     som hör rullningen både på sidan och på .page-wrapper. M-088 tillägget
     12 oktober 2026. Andra ytor som rullar, till exempel förstoringen och
     listor, räknar också om läget. Det är billigt och ändrar inget. */
  const measure = () => {
    passed = target.getBoundingClientRect().bottom < 0;
    if (footer) {
      const rect = footer.getBoundingClientRect();
      atFooter = rect.top < innerHeight && rect.bottom > 0;
    }
    update();
  };
  /* Lådor och mobilmenyn som öppnas eller stängs */
  new MutationObserver(update).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'] });
  document.addEventListener('scroll', measure, { passive: true, capture: true });
  addEventListener('resize', measure);
  new ResizeObserver(measure).observe(document.body);
  measure();

  /* Fokus har flyttat först när focusout är klar */
  bar.addEventListener('focusout', () => setTimeout(update));

  bar.querySelector('[data-nudient-sticky-add]')?.addEventListener('click', () => {
    const button = main.querySelector('.buy-buttons-block [ref="addToCartButton"]');
    if (!button || button.disabled) return;
    button.dataset.puppet = 'true';
    button.click();
  });

  const resetPuppet = (event) => {
    const button = main.querySelector('.buy-buttons-block [ref="addToCartButton"]');
    if (!button) return;
    const reset = () => (button.dataset.puppet = 'false');
    if (event.promise instanceof Promise) event.promise.finally(reset);
    else reset();
  };
  document.addEventListener(StandardEvents.cartLinesUpdate, resetPuppet);
  document.addEventListener(StandardEvents.cartError, resetPuppet);

  notify?.addEventListener('click', () => notifyTarget?.click());
}
